module.exports = __webpack_public_path__ + "assets/retina_AngleIsoscelesDetailed.2c74687df61fcb0987a37ea5a7b8441e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/png/levels/2x/retina_AngleIsoscelesDetailed.png
// module id = 620
// module chunks = 0